<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:40px;">About the Author</h1>
<p>Janice has four children and always wanted them to have an exciting childhood. They attended clubs of interest plus cubs, scouts and brownies. During her working life, she has spent time as a primary school teacher in kindergartens in China, worked in aboriginal communities and taught in a university. She completed her masters in innovation in education because her passion was always to engage and excite children with their education, especially reading interesting stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2c6c000e